import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { isOrderStatusAvailableForFraudChange, OrderDetailsAdminPanel } from '@models';
import { OrderProcessingService } from '@core';
import { catchError, EMPTY, finalize, Observable } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'lib-order-confirm-decline',
  templateUrl: './order-confirm-decline.component.html',
  styleUrls: ['./order-confirm-decline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDividerModule, MatTooltipModule, MatIconModule],
})
export class OrderConfirmDeclineComponent {
  order = input.required<OrderDetailsAdminPanel>();
  label = input<string>("Change order's status");
  onChangeStatus = output();
  isLoading = signal(false);
  disabled = computed(() => !isOrderStatusAvailableForFraudChange(this.order().status) || this.isLoading());
  private snackBar = inject(MatSnackBar);

  private orderProcessingService = inject(OrderProcessingService);

  confirm() {
    this.observableWrapper(this.orderProcessingService.confirm(this.order().id));
  }

  decline() {
    this.observableWrapper(this.orderProcessingService.decline(this.order().id));
  }

  private observableWrapper(obs: Observable<any>): void {
    this.isLoading.set(true);
    obs
      .pipe(
        catchError(() => {
          this.snackBar.open(`Change order status failed`.toUpperCase(), 'Close');
          return EMPTY;
        }),
        finalize(() => {
          this.isLoading.set(false);
          this.onChangeStatus.emit();
          this.snackBar.open(`Change order status succeeded`.toUpperCase(), 'Close');
        }),
      )
      .subscribe();
  }
}
